import React, { Component } from "react";
import { connect } from "react-redux";

import { Container } from "app/NativeComponents/common";
import ListBody from "./ListBody";

class EditList extends Component {
  render() {
    const { show_list_library, device, colors } = this.props;

    return (
      <Container
        style={{
          display: "flex",
          alignSelf: "stretch",
          backgroundColor: colors.card_color
        }}
      >
        <ListBody />
      </Container>
    );
  }
}

const mapStateToProps = ({ settings, native, list }) => {
  const { colors } = settings;
  const { platform, device, isMobile } = native;
  const { show_new_list } = list;

  return {
    colors,
    device,
    isMobile,
    platform,
    show_new_list
  };
};

export default connect(mapStateToProps, {})(EditList);
